/* eslint frontbucket-patterns/no-new-emotion-styled: "warn" */
import styled from '@emotion/styled';
import { InjectedIntl } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';

import Banner from '@atlaskit/banner';
import CrossIcon from '@atlaskit/icon/glyph/cross';
import WarningIcon from '@atlaskit/icon/glyph/warning';
import { token } from '@atlaskit/tokens';

import { LoadStatusPageIncidentsSuccess } from 'src/redux/global/actions/statuspage';
import { incidentBannerDismissed } from 'src/sections/global/components/flags/site-message/site-message-store';
import { getCurrentUserUuid } from 'src/selectors/user-selectors';
import { SiteMessage } from 'src/types/site-message';

import messages from '../sections/global/components/flags/site-message/site-message-flag.i18n';

import { DismissButton } from './site-banner.style';

type Props = { siteMessage?: SiteMessage; intl: InjectedIntl };

const MessagePadding = styled.span({
  paddingRight: token('space.050'),
});

const SiteBanner = (props: Props) => {
  const currentUserUuid = useSelector(getCurrentUserUuid);
  const dispatch = useDispatch();
  const {
    siteMessage,
    intl: { formatMessage },
  } = props;
  if (!siteMessage) {
    return null;
  }

  const onDismiss = (userId: string) => {
    incidentBannerDismissed(userId, siteMessage.id);
    // force banner refresh
    dispatch(LoadStatusPageIncidentsSuccess([]));
  };

  const message =
    siteMessage.linkType === 'refresh' ? (
      <MessagePadding>
        {siteMessage.text}{' '}
        <a href={window.location.href}>
          {formatMessage(messages.refreshButton)}
        </a>
      </MessagePadding>
    ) : (
      <MessagePadding>
        {siteMessage.text} &mdash;{' '}
        <a href={siteMessage.url} target="_new" rel="noopener">
          {formatMessage(messages.learnMoreButton)}
        </a>
      </MessagePadding>
    );

  return (
    <Banner
      icon={
        <WarningIcon
          label="Site Message Warning Icon"
          secondaryColor="inherit"
        />
      }
    >
      {message}
      {siteMessage.isIncident && currentUserUuid && (
        <DismissButton
          testId="dismiss-incident-banner"
          aria-label="dismiss incident banner"
          onClick={() => onDismiss(currentUserUuid)}
          appearance="subtle"
          iconBefore={<CrossIcon label="dismiss-incident-banner" />}
        />
      )}
    </Banner>
  );
};

export default SiteBanner;
